













































































































































import EventBus from '@/plugins/EventBus'
import { MotivoRecusaDoOrcamento, OrcamentoAcaoEnum } from '@/types/_'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoPendenciaStore from '../SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import SolicitacaoStore from './store/SolicitacaoStore'

@Component
export default class ModalAprovarOuRecusarOrcamento extends Vue {
  $refs!: {
    orcamento: any,
    motivoDeRecusa: any,
  }

  loadingAprovarOrcamento = false
  loadingRecusarOrcamento = false
  loadingInformarMotivoDeRecusaDoOrcamento = false
  modalMotivoDeRecusaDoOrcamento = false

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get modalAprovarOuRecusarOrcamento() { return this.getSolicitacaoPendenciaStore.modalAprovarOuRecusarOrcamento }
  set modalAprovarOuRecusarOrcamento(value: boolean) { this.getSolicitacaoPendenciaStore.setModalAprovarOuRecusarOrcamento(value) }

  get getOrcamentoAnexo() {
    return this.getSolicitacaoStore.orcamentoAnexo
  }

  get motivosDeRecusa() {
    return this.getSolicitacaoPendenciaStore.motivosDeRecusa
  }

  motivoDeRecusaRules: any = {
    valid: true,
    motivoRecusaDoOrcamento: [(v: string) => !!v || 'Campo obrigatório.'],
  }

  disabledMotivoDeRecusa() {
    if (this.escolhaDoMotivoDeRecusa && this.escolhaDoMotivoDeRecusa.id) return '00000000-0000-0000-0000-000000000000' !== this.escolhaDoMotivoDeRecusa.id
    return false
  }

  escolhaDoMotivoDeRecusa: MotivoRecusaDoOrcamento | undefined = undefined
  motivoRecusaDoOrcamento: string = ''

  setMotivoDeRecusa(motivo: MotivoRecusaDoOrcamento) {
    if (motivo.id === '00000000-0000-0000-0000-000000000000') {
      this.motivoRecusaDoOrcamento = ''
      return
    }

    this.motivoRecusaDoOrcamento = ''
    this.motivoRecusaDoOrcamento = motivo.descricao
  }

  get currentUserHospitals() {
    return this.getSolicitacaoStore.currentUserHospitals
  }

  get hospitalInformaMotivoDeRecusaDoOrcamento() {
    const { hospitalId } = this.getSolicitacaoPendenciaStore.agendamentoMedico
    const hospital = this.currentUserHospitals.find((h: any) => h.id === hospitalId) || { hospitalInformaMotivoDeRecusaDoOrcamento : false }
    return !!hospital.hospitalInformaMotivoDeRecusaDoOrcamento
  }

  async recusarOrcamento() {
    if (this.orcamentoId) {
      this.orcamentoId = ''
      this.$refs.orcamento.resetValidation()
      this.$refs.orcamento.reset()
    }

    if (this.hospitalInformaMotivoDeRecusaDoOrcamento) {
      this.modalMotivoDeRecusaDoOrcamento = true
      return
    }

    this.loadingRecusarOrcamento = true

    const params: any = {
      solicitacaoId: this.getSolicitacaoPendenciaStore.pendencia.solicitacaoId,
      resposta: OrcamentoAcaoEnum.OrcamentoRecusado,
      descricaoMotivoRecusaDoOrcamento: '',
    }

    const response = await this.getSolicitacaoStore.medicoRespondeOrcamentoDeCirurgiaParticular(params)

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingRecusarOrcamento = false
      return
    }

    this.getSolicitacaoPendenciaStore.setAgendamentoMedico(response.data.solicitacao)
    EventBus.$emit('setSnackbar', { show: true, text: `Orçamento recusado com sucesso.`, icon: 'warning', color: '#C62828' })
    this.loadingRecusarOrcamento = false
  }

  async informarMotivoDeRecusaDoOrcamento() {
    if (!this.$refs.motivoDeRecusa.validate()) return

    this.loadingInformarMotivoDeRecusaDoOrcamento = true

    const params: any = {
      solicitacaoId: this.getSolicitacaoPendenciaStore.pendencia.solicitacaoId,
      resposta: OrcamentoAcaoEnum.OrcamentoRecusado,
      descricaoMotivoRecusaDoOrcamento: String(this.motivoRecusaDoOrcamento),
    }

    const response = await this.getSolicitacaoStore.medicoRespondeOrcamentoDeCirurgiaParticular(params)

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingInformarMotivoDeRecusaDoOrcamento = false
      return
    }

    this.getSolicitacaoPendenciaStore.setAgendamentoMedico(response.data.solicitacao)
    EventBus.$emit('setSnackbar', { show: true, text: `Motivo informado com sucesso. ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
    this.loadingInformarMotivoDeRecusaDoOrcamento = false
    this.modalMotivoDeRecusaDoOrcamento = false
    this.modalAprovarOuRecusarOrcamento = false
  }

  orcamentoId: string = ''
  orcamentoRules: any = {
    valid: true,
    orcamentoId: [(v: string) => !!v || 'Campo obrigatório.'],
  }

  async aprovarOrcamento() {
    if (!this.$refs.orcamento.validate()) return

    this.loadingAprovarOrcamento = true

    const params: any = {
      solicitacaoId: this.getSolicitacaoPendenciaStore.pendencia.solicitacaoId,
      resposta: OrcamentoAcaoEnum.OrcamentoAprovado,
      orcamentoAprovadoId: this.orcamentoId,
    }

    const response = await this.getSolicitacaoStore.medicoRespondeOrcamentoDeCirurgiaParticular(params)

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAprovarOrcamento = false
      return
    }

    this.getSolicitacaoPendenciaStore.setAgendamentoMedico(response.data.solicitacao)
    EventBus.$emit('setSnackbar', { show: true, text: `Orçamento aprovado com sucesso. ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
    this.loadingAprovarOrcamento = false
    this.modalAprovarOuRecusarOrcamento = false
  }

  @Watch('modalMotivoDeRecusaDoOrcamento')
  onChangeModalMotivoDeRecusaDoOrcamento(value: boolean) {
    if (!value) {
      this.$refs.motivoDeRecusa.resetValidation()
      this.$refs.motivoDeRecusa.reset()
      this.escolhaDoMotivoDeRecusa = undefined
      this.motivoRecusaDoOrcamento = ''
      this.loadingInformarMotivoDeRecusaDoOrcamento = false
    }
  }

  @Watch('modalAprovarOuRecusarOrcamento')
  onChangeModalAprovarOuRecusarOrcamento(value: boolean) {
    if (!value) {
      this.loadingAprovarOrcamento = false
      this.loadingRecusarOrcamento = false
      this.$refs.orcamento.resetValidation()
      this.$refs.orcamento.reset()
      this.modalMotivoDeRecusaDoOrcamento = false
      this.escolhaDoMotivoDeRecusa = undefined
      this.motivoRecusaDoOrcamento = ''
      this.loadingInformarMotivoDeRecusaDoOrcamento = false
    }
  }
}
